/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { connect } from 'react-redux'

import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
  VirtualizedCell,
  extractAndFormatData,
} from '@integec/grid-tools'
import { rowHeaderRender } from 'core/utils'
import moment from 'moment'
import R from 'ramda'
import { getUserInfo } from 'core/selectors'

const EditableGrid = ({
  height,
  width,
  header,
  altBy,
  fuzzyFilter,
  isEditable = true,
  editInfo,
  setEditInfo,
  data = [],
  setData,
  sortEnabled = false,
  autoFixColByKey = false,
  initialSortOptions = undefined,
  sortOptions = undefined,
  headerRowHeight = 60,
  cellRender,
  cref,
  onSelectionChange = _ => _,
  userInfo = {},
  selectionMode = 'single',
}) => {
  // let [editInfo, setEditInfo] = useState(freeEditEngine.generateInitialEditInfo())
  // let [data, setData] = useState(gridData || [])
  // useEffect(d => setData(gridData), [gridData])
  const editRow = editInfo => {
    const modData = data.map(d => {
      if (editInfo.updatedMap.get(d)) {
        return {
          ...editInfo.updatedMap.get(d),
          updated: true,
          modificationInfo: { user: userInfo.userName, modDate: moment() },
        }
      } else {
        return d
      }
    })

    let editData = editInfo.updated
    editData = editData.map(d => {
      return {
        ...d,
        modificationInfo: { user: null, modDate: moment() },
      }
    })
    setData(modData)
    setEditInfo({ ...editInfo, updated: editData })
    // setEditInfo({ data: modData, editInfo: { ...editInfo, updated: editData } })
  }
  const customizedCellRender = params => {
    const { gridToolProps, reactVirtualizedProps } = params

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    // const cellProps = getCellProps({
    //   rowIndex,
    //   columnIndex,
    //   header: headers[columnIndex],
    //   data,
    //   style,
    //   ...rest,
    // })

    const cellData = extractAndFormatData({
      rowData: data[rowIndex],
      header: headers[columnIndex],
    })

    let cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    cellProps = {
      ...cellProps,
      style: {
        ...style,
        backgroundColor: data[rowIndex].updated ? '#FFFC33' : undefined,
        color:
          cellProps.isSelected && data[rowIndex].updated ? 'black' : undefined,
      },
    }
    const rd = { ...R.omit(['data', 'headers'], cellProps) }
    if (cellProps.isEditing) {
      // const computedEditRender =
      //   cellProps.editRender || cellProps.header.choices ? dropdownEditRender : inputCellEditRender

      // return <CellEditContainer {...cellProps} render={computedEditRender} />
      return defaultVirtualizedCellRender(params)
    }

    return (
      <VirtualizedCell
        // reactVirtualizedProps={reactVirtualizedProps}
        // gridToolProps={gridToolProps}
        // {...gridToolProps}
        // {...cellProps}
        {...rd}
      >
        {cellData}
      </VirtualizedCell>
    )

    // return defaultVirtualizedCellRender(params)
  }
  return (
    <Grid
      ref={cref}
      editMode="cell"
      sortEnabled={sortEnabled}
      data={data}
      headers={header}
      altBy={altBy}
      altBgColor="#ebebeb"
      onEditInfoChange={info => editRow(info)}
      editInfo={editInfo}
      render={virtualizedGridRenderer({
        autoFixColByKey,
        rowHeaderRender,
        height: height - 30,
        width: width - 10,
        cellRender: cellRender || customizedCellRender,
        headerRowHeight,
        selectionMode,
      })}
      fuzzyFilter={fuzzyFilter}
      isEditable={isEditable}
      initialSortOptions={initialSortOptions}
      sortOptions={sortOptions}
      onSelectionChange={onSelectionChange}
      selectionMode={selectionMode}
    />
  )
}

const mapStateToProps = state => ({
  userInfo: getUserInfo(state),
})
export default connect(mapStateToProps)(EditableGrid)
